// extracted by mini-css-extract-plugin
module.exports = {"container":"post_container__8RZ4V","withVideo":"post_withVideo__d1VaC","content":"post_content__49YVo","skeleton_animate":"post_skeleton_animate__ynRt0"};